module.exports = __webpack_public_path__ + "static/img/logo_eitdigital.64d0a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logo_eitdigital.png
// module id = E6IK
// module chunks = 0